/**
 * 将JSON对象转换为Tree组件所需的树形数据结构
 * @param {Object} jsonData - JSON对象
 * @param {string} parentKey - 父节点的key（用于生成唯一标识）
 * @param {number} level - 当前层级（用于样式区分）
 * @returns {Array} 树形数据数组
 */
export const convertJsonToTreeData = (jsonData, parentKey = 'root', level = 0) => {
  if (!jsonData || typeof jsonData !== 'object') {
    return [];
  }

  return Object.keys(jsonData).map((key, index) => {
    const value = jsonData[key];
    const nodeKey = `${parentKey}-${index}`;

    // 如果value是对象，递归处理
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return {
        title: key,
        key: nodeKey,
        level: level,
        nodeType: 'branch',
        children: convertJsonToTreeData(value, nodeKey, level + 1)
      };
    }

    // 如果是基本类型，作为叶子节点
    return {
      title: key,
      key: nodeKey,
      level: level,
      nodeType: 'leaf',
      isLeaf: true
    };
  });
};

/**
 * 指标树节点的颜色配置
 * 根据层级和节点类型返回不同的样式配置
 */
export const getMetricTreeNodeStyle = (level, nodeType) => {
  // 层级颜色配置
  const levelColors = [
    { bg: '#e6f7ff', border: '#1890ff', text: '#1890ff', icon: 'folder' },      // 第0层 - 蓝色
    { bg: '#f6ffed', border: '#52c41a', text: '#52c41a', icon: 'folder-open' }, // 第1层 - 绿色
    { bg: '#fff7e6', border: '#fa8c16', text: '#fa8c16', icon: 'file' },        // 第2层 - 橙色
    { bg: '#fff1f0', border: '#f5222d', text: '#f5222d', icon: 'file-text' },   // 第3层 - 红色
    { bg: '#f9f0ff', border: '#722ed1', text: '#722ed1', icon: 'tag' },         // 第4层 - 紫色
  ];

  // 叶子节点使用对应层级的颜色，但图标固定为 tag
  const style = levelColors[level % levelColors.length];
  if (nodeType === 'leaf') {
    return {
      ...style,
      icon: 'tag'
    };
  }

  // 根据层级返回对应颜色，超出范围则循环使用
  return style;
};

/**
 * 获取树形数据中的所有key（用于默认展开）
 * @param {Array} treeData - 树形数据
 * @returns {Array} 所有节点的key数组
 */
export const getAllTreeKeys = (treeData) => {
  let keys = [];
  const traverse = (nodes) => {
    nodes.forEach(node => {
      keys.push(node.key);
      if (node.children) {
        traverse(node.children);
      }
    });
  };
  traverse(treeData);
  return keys;
};

/**
 * 缩略显示JSON字符串
 * @param {string|Object} jsonData - JSON数据
 * @param {number} maxLength - 最大显示长度
 * @returns {string} 缩略后的字符串
 */
export const truncateJson = (jsonData, maxLength = 50) => {
  if (!jsonData) return '-';
  
  try {
    const jsonStr = typeof jsonData === 'string' ? jsonData : JSON.stringify(jsonData);
    if (jsonStr.length <= maxLength) {
      return jsonStr;
    }
    return jsonStr.substring(0, maxLength) + '...';
  } catch (e) {
    return '-';
  }
};
